const HEX = "12,1.5 21.5,7 21.5,17 12,22.5 2.5,17 2.5,7";

// API RP 1637 style color-symbol: circle = gasoline, hexagon = distillate; Jet-A uses black with white text.
export const ApiSymbol = ({ p, size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className="api-symbol" aria-label={`${p.name} API color ${p.api}`}>
    {p.shape === "circle" && <circle cx="12" cy="12" r="10.5" fill={p.color} stroke="#94a3b8" strokeWidth="1" />}
    {p.shape === "hex" && <polygon points={HEX} fill={p.color} stroke="#94a3b8" strokeWidth="1" />}
    {p.shape === "square" && <rect x="1.5" y="1.5" width="21" height="21" rx="2" fill={p.color} stroke="#e5e7eb" strokeWidth="1.5" />}
    {p.mark && <text x="12" y="15.5" textAnchor="middle" fontSize={p.mark.length > 2 ? 8 : 10} fontWeight="800"
      fontFamily="JetBrains Mono, monospace" fill={p.markColor}>{p.mark}</text>}
  </svg>
);

export const ProductLabel = ({ p }) => (
  <span className="dot-label"><ApiSymbol p={p} />{p.name}</span>
);
